const properties = {
    buildId: '202610.0',
    contextPath: 'https://rckms.aimsplatform.org',
    rsBaseServiceUri: 'https://rckms-mts.authoring.prod2.aimsplatform.org',
    rsCrudContextPath: '/mts-rs-{0}',
    reportsServiceEndpoint: 'https://rckms-rrs.authoring.prod2.aimsplatform.org',
};

export default properties;
